import { render, staticRenderFns } from "./RankingKleague.vue?vue&type=template&id=7cd6924d"
import script from "./RankingKleague.vue?vue&type=script&lang=js"
export * from "./RankingKleague.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports